export default __webpack_public_path__ + "images/Natura2000.jpg";